<template>
  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-1>
      <v-layout column v-for="(name, index) in Object.keys(getTable)" :key="index"  fill-height ma-0 pa-0>
        <v-flex >
            <scroll-table
              :subscribed="false"
              :reload="true"
              :data="getTable[name]"
              :options="getOptions"
              @value="(payload)=>onSelect(payload, name)"
              @reload="()=>onReload()"
            />
        </v-flex>
        <v-flex v-show="addButtonShow" shrink @click="">
          <v-btn :data-testid="$options.name + 'v-btn' + 'onCreate-name'" dark small @click="()=>onCreate(name)" color="primary">{{$t('add new')}}</v-btn>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1000px" v-if="dialog.open">
      <rest-card
        :data="getDialogData"
        :parentData="getData"
        :addMode="getDialogMode"
        :descriptions="getDescriptions"
        @update="(payload) => onUpdate(payload, 'vlanConfiguration')"
        @add="(payload) => onAdd(payload, 'vlanConfiguration')"
        @remove="(payload) => onRemove(payload, 'vlanConfiguration')"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import RestCard from '@/nms/components/device-configuration/manage/page/rest-card.vue'
import loader from '@/nms/components/partials/loader.vue'

// Типы
interface DescriptorMethod {
  name: string
  rest?: string
  parameters?: Record<string, any>
  accepts?: Record<string, any>
}

interface Descriptor {
  name: string
  type?: string
  descriptions?: Record<string, string>
  method: {
    get?: DescriptorMethod
    update?: DescriptorMethod
    add?: DescriptorMethod
    remove?: DescriptorMethod
  }
  dataModel?: {
    data?: any[]
  }
  [key: string]: any
}

interface DescriptorsMap {
  [key: string]: Descriptor
}

interface TableData {
  columns: Array<{ title: string; value: string; type: string }>
  rows: any[]
}

interface TablesMap {
  [key: string]: TableData
}

interface DialogState {
  open: boolean
  addMode: boolean
  name: string | null
  data: any | null
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ModelData {
  [key: string]: any
}

interface UniConfigurationData {
  [key: string]: any
}

interface ActiveTreeItem {
  id?: string
  descriptor?: Descriptor | Descriptor[]
  [key: string]: any
}

export default Vue.extend({
  name: 'UNI_CONFIGURATION',

  components: {
    scrollArea,
    scrollTable,
    RestCard,
    loader
  },

  props: {
    data: {
      type: Object as () => UniConfigurationData,
      default: () => ({})
    },
    treeActive: {
      type: Array as () => ActiveTreeItem[],
      default: () => []
    },
  },

  data(): {
    descriptors: DescriptorsMap
    descriptions: Record<string, string>
    addButtonShow: boolean
    model: ModelData
    options: OptionsData
    search: string
    descriptionData: Record<string, any>
    tableData: any | null
    table: TablesMap
    dialog: DialogState
  } {
    return {
      descriptors: {},
      descriptions: {},
      addButtonShow: false,
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      descriptionData: {},
      tableData: null,
      table: {},
      dialog: {
        open: false,
        addMode: false,
        name: null,
        data: null,
      },
    }
  },

  computed: {
    getData(): UniConfigurationData {
      return this.data
    },

    getDialogData(): any | null {
      return this.dialog.data
    },

    getDialogMode(): boolean {
      return this.dialog.addMode
    },

    getDescriptions(): Record<string, string> {
      return this.descriptions
    },

    getActiveTree(): ActiveTreeItem[] {
      return this.treeActive
    },

    getTable(): TablesMap {
      return this.$merge({}, this.table) as TablesMap
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  watch: {
    data: {
      handler(): void {
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.reset()
      
      const activeTree = this.getActiveTree
      if (activeTree[0]?.descriptor) {
        if (Array.isArray(activeTree[0].descriptor)) {
          activeTree[0].descriptor.forEach(item => {
            this.loadDescriptorData(item)
          })
        } else {
          this.loadDescriptorData(activeTree[0].descriptor)
        }
      }
    },

    async loadDescriptorData(descriptor: Descriptor): Promise<void> {
      console.log(this.$options.name, 'loadDescriptorData', 'descriptor', descriptor)
      
      try {
        if (descriptor.descriptions) {
          Object.keys(descriptor.descriptions).forEach(key => {
            this.$set(this.descriptions, key, descriptor.descriptions![key])
          })
        }
        
        if (!descriptor.method?.get) {
          console.log(this.$options.name, 'loadDescriptorData', '!descriptor.method.get', descriptor)
          return
        }
        
        if (descriptor.method.add) {
          this.addButtonShow = true
        }
        
        this.$set(this.descriptors, descriptor.name, descriptor)
        
        const path = descriptor.method.get.name
        const rest = descriptor.method.get.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.get.parameters) {
          Object.keys(descriptor.method.get.parameters).forEach(key => {
            const paramValue = descriptor.method.get!.parameters![key]
            if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const value = Object.keys(this.getData).find(val => val === paramValue)
              if (value) {
                params[key] = this.getData[paramValue]
              } else {
                params[key] = (this as any)[paramValue]
              }
            } else {
              params[key] = paramValue
            }
          })
        }

        console.log(this.$options.name, 'loadDescriptorData', 'params', params)
        const descriptorData = await this.$bridge.customQuery('alarm', path, params, rest)
        console.log(this.$options.name, 'loadDescriptorData', 'descriptorData', descriptorData)
        
        if (descriptorData) {
          this.$set(this.descriptors[descriptor.name], 'dataModel', descriptorData)
          this.$set(this.model, descriptor.name, { value: null })
          
          if (this.descriptors[descriptor.name].type === 'table') {
            this.prepareTableData(this.descriptors[descriptor.name])
          }
        }

        console.log(this.$options.name, 'loadDescriptorData', 'this.descriptors', this.descriptors)
        console.log(this.$options.name, 'loadDescriptorData', 'this.descriptions', this.descriptions)
      } catch (error) {
        console.error(this.$options.name, 'loadDescriptorData smth wrong', error)
      }
    },

    async prepareTableData(payload: Descriptor): Promise<void> {
      console.log('UNI_CONFIGURATION', 'prepareTableData', 'payload', payload)
      
      this.$set(this.table, payload.name, { columns: [], rows: [] })
      
      try {
        if (payload.dataModel?.data?.length) {
          Object.keys(payload.dataModel.data[0]).forEach(field => {
            this.table[payload.name].columns.push({
              title: field,
              value: field,
              type: 'text',
            })
          })
          this.table[payload.name].rows = payload.dataModel.data
        }
      } catch (error) {
        console.error('UNI_CONFIGURATION', 'prepareTableData smth wrong', error)
      }
    },

    onSelect(val: any, name: string): void {
      console.log(this.$options.name, 'onSelect', 'val', val)
      console.log(this.$options.name, 'onSelect', 'name', name)
      
      if (!this.addButtonShow) return
      
      if (val) {
        this.$set(this.dialog, 'data', val)
        this.$set(this.dialog, 'name', name)
        this.$set(this.dialog, 'open', true)
      }
    },

    onDialogClose(): void {
      console.log(this.$options.name, 'onDialogClose')
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'name', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    onCreate(name: string): void {
      console.log(this.$options.name, 'onCreate')
      
      const descriptor = this.descriptors[name]
      if (!descriptor) {
        console.log(this.$options.name, 'onCreate', '!name', name)
        return
      }
      if (!descriptor.method?.add) {
        console.log(this.$options.name, 'onCreate', '!descriptor.method.add', descriptor)
        return
      }
      
      const obj: Record<string, any> = {}
      if (descriptor.method.add.parameters?.accepts) {
        Object.keys(descriptor.method.add.parameters.accepts).forEach(key => {
          obj[key] = null
        })
      }
      
      this.$set(this.dialog, 'data', obj)
      this.$set(this.dialog, 'name', name)
      this.$set(this.dialog, 'addMode', true)
      this.$set(this.dialog, 'open', true)
    },

    getInnerParams(parent: Record<string, any>, obj: Record<string, any>): Record<string, any> {
      const innerParams: Record<string, any> = {}
      // console.log(this.$options.name, 'getInnerParams', 'parent', parent)
      // console.log(this.$options.name, 'getInnerParams', 'obj', obj)
      Object.keys(parent).forEach(innerKey => {
        if (typeof parent[innerKey] === 'object') {
          innerParams[innerKey] = this.getInnerParams(parent[innerKey], obj)
        } else if (typeof parent[innerKey] === 'string' && parent[innerKey].substring(0, 1) === '$') {
          const value = Object.keys(this.getData).find(val => val === innerKey)
          if (value) {
            innerParams[innerKey] = this.getData[innerKey]
          } else {
            innerParams[innerKey] = obj[innerKey]
          }
        } else {
          innerParams[innerKey] = parent[innerKey]
        }
      })
      
      return innerParams
    },

    async onUpdate(val: any): Promise<void> {
      console.log(this.$options.name, 'onUpdate', 'val', val)
      
      try {
        const name = this.dialog.name as string
        const descriptor = this.descriptors[name]
        console.log(this.$options.name, 'onUpdate', 'descriptor', descriptor)
        
        if (!descriptor?.method?.update) {
          console.log(this.$options.name, 'onUpdate', '!descriptor.method.update', descriptor)
          return
        }
        
        const path = descriptor.method.update.name
        const rest = descriptor.method.update.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.update.parameters) {
          Object.keys(descriptor.method.update.parameters).forEach(key => {
            const paramValue = descriptor.method.update!.parameters![key]
            if (typeof paramValue === 'object') {
              console.log(this.$options.name, 'onUpdate', 'params OBJECT', key, paramValue)
              if(val.obj) {
                params[key] = this.getInnerParams(paramValue, val.obj)
              } 
              else {
                params[key] = this.getInnerParams(paramValue, val)
              }
            } else if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const foundKey = Object.keys(this.getData).find(k => k === paramValue)
              if (foundKey) {
                params[key] = this.getData[paramValue]
              } else {
                if(val.obj) {
                  params[key] = val.obj[key]
                } 
                else {
                  params[key] = val[key]
                }
              }
            } else {
              params[key] = paramValue
            }
          })
        }
        
        // console.log(this.$options.name, 'onUpdate', 'path', path)
        // console.log(this.$options.name, 'onUpdate', 'params', params)
        // console.log(this.$options.name, 'onUpdate', 'rest', rest)

        if(val.group && val.group.length) {
          let newItems = []
          for (let item of val.group) {
            params.id = item
            let newItem = await this.$bridge.customQuery('alarm', path, params, rest)
            if (newItem) {
              newItems.push(newItem)
            }
          }
          if(newItems.length && descriptor) {
            this.loadDescriptorData(descriptor)
            this.$emit('update', this.getData)
          }
          // console.log(this.$options.name, 'onAdd', 'newItem', newItem)
        }
        else {
          let newItem = await this.$bridge.customQuery('alarm', path, params, rest)
          if (newItem && descriptor) {
            this.loadDescriptorData(descriptor)
            this.$emit('update', this.getData)
          }
          // console.log(this.$options.name, 'onAdd', 'newItem', newItem)
        }    

        // const descriptorData = await this.$bridge.customQuery('alarm', path, params, rest)
        // console.log(this.$options.name, 'onUpdate', 'descriptorData', descriptorData)
        
        // if (descriptorData && descriptor) {
        //   this.loadDescriptorData(descriptor)
        //   this.$emit('update', this.getData)
        // }
        
      } catch (error) {
        console.error(this.$options.name, 'onUpdate smth wrong', error)
      }
    },

    async onAdd(val: any): Promise<void> {
      console.log(this.$options.name, 'onAdd', 'val', val)
      
      try {
        const name = this.dialog.name as string
        const descriptor = this.descriptors[name]
        console.log(this.$options.name, 'onAdd', 'descriptor', descriptor)
        
        if (!descriptor?.method?.add) {
          console.log(this.$options.name, 'onAdd', '!descriptor.method.add', descriptor)
          return
        }
        
        const path = descriptor.method.add.name
        const rest = descriptor.method.add.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.add.parameters) {
          Object.keys(descriptor.method.add.parameters).forEach(key => {
            const paramValue = descriptor.method.add!.parameters![key]
            if (typeof paramValue === 'object') {
              console.log(this.$options.name, 'onAdd', 'params OBJECT', key, paramValue)
              if(val.obj) {
                params[key] = this.getInnerParams(paramValue, val.obj)
              } 
              else {
                params[key] = this.getInnerParams(paramValue, val)
              }
            } else if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const foundKey = Object.keys(this.getData).find(k => k === paramValue)
              if (foundKey) {
                params[key] = this.getData[paramValue]
              } else {
                if(val.obj) {
                  params[key] = val.obj[key]
                } 
                else {
                  params[key] = val[key]
                }
              }
            } else {
              params[key] = paramValue
            }
          })
        }
        
        // console.log(this.$options.name, 'onAdd', 'path', path)
        // console.log(this.$options.name, 'onAdd', 'params', params)
        // console.log(this.$options.name, 'onAdd', 'rest', rest)

        if(val.group && val.group.length) {
          let newItems = []
          for (let item of val.group) {
            params.id = item
            let newItem = await this.$bridge.customQuery('alarm', path, params, rest)
            if (newItem) {
              newItems.push(newItem)
            }
          }
          if(newItems.length && descriptor) {
            this.loadDescriptorData(descriptor)
            this.$emit('update', this.getData)
          }
          // console.log(this.$options.name, 'onAdd', 'newItem', newItem)
        }
        else {
          let newItem = await this.$bridge.customQuery('alarm', path, params, rest)
          if (newItem && descriptor) {
            this.loadDescriptorData(descriptor)
            this.$emit('update', this.getData)
          }
          // console.log(this.$options.name, 'onAdd', 'newItem', newItem)
        }       
      } catch (error) {
        console.error(this.$options.name, 'onAdd smth wrong', error)
      }
    },

    async onRemove(val: any): Promise<void> {
      console.log(this.$options.name, 'onRemove', 'val', val)
      
      try {
        const name = this.dialog.name as string
        const descriptor = this.descriptors[name]
        console.log(this.$options.name, 'onRemove', 'descriptor', descriptor)
        
        if (!descriptor?.method?.remove) {
          console.log(this.$options.name, 'onRemove', '!descriptor.method.remove', descriptor)
          return
        }
        
        const path = descriptor.method.remove.name
        const rest = descriptor.method.remove.rest || 'GET'
        const params: Record<string, any> = {}
        
        if (descriptor.method.remove.parameters) {
          Object.keys(descriptor.method.remove.parameters).forEach(key => {
            const paramValue = descriptor.method.remove!.parameters![key]
            if (typeof paramValue === 'object') {
              console.log(this.$options.name, 'onRemove', 'params OBJECT', key, paramValue)
              if(val.obj) {
                params[key] = this.getInnerParams(paramValue, val.obj)
              } 
              else {
                params[key] = this.getInnerParams(paramValue, val)
              }
            } else if (typeof paramValue === 'string' && paramValue.substring(0, 1) === '$') {
              const foundKey = Object.keys(this.getData).find(k => k === paramValue)
              if (foundKey) {
                params[key] = this.getData[paramValue]
              } else {
                if(val.obj) {
                  params[key] = val.obj[key]
                } 
                else {
                  params[key] = val[key]
                }
              }
            } else {
              params[key] = paramValue
            }
          })
        }

        if(val.group && val.group.length) {
          let newItems = []
          for (let item of val.group) {
            params.id = item
            let newItem = await this.$bridge.customQuery('alarm', path, params, rest)
            if (newItem) {
              newItems.push(newItem)
            }
          }
          if(newItems.length && descriptor) {
            this.loadDescriptorData(descriptor)
            this.$emit('update', this.getData)
          }
          // console.log(this.$options.name, 'onAdd', 'newItem', newItem)
        }
        else {
          let newItem = await this.$bridge.customQuery('alarm', path, params, rest)
          if (newItem && descriptor) {
            this.loadDescriptorData(descriptor)
            this.$emit('update', this.getData)
          }
          // console.log(this.$options.name, 'onAdd', 'newItem', newItem)
        }   
        
        // console.log(this.$options.name, 'onRemove', 'params', params)
        // const result = await this.$bridge.customQuery('alarm', path, params, rest)
        // console.log(this.$options.name, 'onRemove', 'result', result)
        
        // if (result && descriptor) {
        //   this.loadDescriptorData(descriptor)
        //   this.$emit('update', this.getData)
        // }
      } catch (error) {
        console.error(this.$options.name, 'onRemove smth wrong', error)
      }
    },

    onReload(): void {
      console.log(this.$options.name, 'onReload')
      this.setup()
    },

    reset(): void {
      this.search = ''
      this.descriptionData = {}
      this.tableData = null
      this.table = {}
      this.dialog = {
        open: false,
        addMode: false,
        name: null,
        data: null,
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
